<template>
  <AsyncImage
    class="h-64 mx-auto"
    :src="getAbsoluteAssetLink('nami/stickers/sad.png')"
  />
  <p class="text-center">An error has occurred.</p>
  <p class="text-red-500 text-center text-sm">
    {{ error }}
  </p>
  <div class="flex justify-center mt-2">
    <NamiButton buttonType="primary" text @buttonClick="$emit('retry')">
      Try again
    </NamiButton>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  error: Error | string;
}>();

defineEmits<{
  (e: "retry"): void;
}>();
</script>
